define('gmapsapi',[], function() {

  var GMapsAPI = {};

  GMapsAPI.load_api = function(cb) {

    require(['domReady!'], function() {
      require(['async!//maps.google.com/maps/api/js?key=AIzaSyBkyx6gv4T1tX_R0nn10dbWaLtEjEW-aqE'], function() {
          if (typeof cb === 'function') {
            cb();
          }
      });
    });

  };

  return GMapsAPI;

});

